import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackPage } from "../utils/analytics";

const routeTitles = {
  "/": "Dashboard",
  "/store-management": "Dashboard",
  "/sm-product-list": "Inventory Management",
  "/sm-planning": "Goals & KPIs",
  "/advanced-business-report": "Advanced Report",
  "/sm-agents": "Agents",
  "/store-products-analysis": "Store Analysis",
  "/sm-analytics": "Analytics",
  "/niche-scrape": "Niche Scrape",
  "/niche-analysis": "Niche Analysis",
  "/niche-over-time": "Niche Over Time",
  "/niche-ranking": "Niche Ranking",
  "/auth/sign-in": "Sign In",
  "/auth/sign-up": "Sign Up",
  "/auth/amazon/connect": "Amazon Connect",
  "/auth/amazon/callback": "Amazon Callback",
  "/auth/amazon/success": "Amazon Success",
  "/auth/amazon/error": "Amazon Error",
  "/auth/amazon/ads/connect": "Amazon Ads Connect",
  "/auth/amazon/ads/callback": "Amazon Ads Callback",
  "/auth/amazon/ads/success": "Amazon Ads Success",
};

function getPageTitle(pathname) {
  if (routeTitles[pathname]) return routeTitles[pathname];

  const productDetailMatch = pathname.match(/\/sm-product-details\/(.+)/);
  if (productDetailMatch) return "Product Details";

  const productSKUMatch = pathname.match(/\/product-dashboard\/(.+)/);
  if (productSKUMatch) return "Product SKU Dashboard";

  return pathname;
}

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const title = getPageTitle(location.pathname);
    trackPage(location.pathname + location.search, title);
  }, [location]);
}
